import { Component, computed, effect, inject, input, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormDropdownComponent } from '@program-suite/ui';
import { AgencyStore, LookupViewModel } from '@program-suite/data-common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormTextComponent } from '@program-suite/ui';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent, FormPhoneComponent, ModalLayoutComponent } from '@program-suite/ui';
import { AgentViewModel } from '@program-suite/data-common';

@Component({
  selector: 'lib-edit-user-modal',
  imports: [
    CommonModule,
    ModalLayoutComponent,
    FormDropdownComponent,
    FormTextComponent,
    FormPhoneComponent,
    ReactiveFormsModule,
    ButtonComponent,
],
  templateUrl: './edit-user-modal.component.html',
  styleUrl: './edit-user-modal.component.scss',
})
export class EditUserModalComponent implements OnDestroy{
  agencyStore = inject(AgencyStore);
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<EditUserModalComponent>);

  // Todo: We may need a shared UserInfoForm component to handle this
  editUserForm!: FormGroup;
  producers = signal<LookupViewModel[]>(this.data?.producers || []);
  roles = signal<LookupViewModel[]>(this.data.roles || []);
  agent = computed(() => this.agencyStore.agent() ?? null);
  role = computed(() => this.roles().find(r => r.name === this.agent()?.role) ?? null);
  subtitle = computed(() => {
    const agent = this.agent();
    if (agent) {
      return `${agent.firstName} ${agent.lastName} | ${this.data.agencyName}`;
    }
    return '';
  });

  constructor(
    private fb: FormBuilder,
  ) {
    this.editUserForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', Validators.required],
      phone: ['', Validators.required],
      agency: ['', Validators.required],
      role: ['', Validators.required],
      isActive: ['', Validators.required],
    });

    // Reactively update the form when agent changes
    effect(() => {
      const agent = this.agent();
      if (agent) { 
        this.editUserForm.patchValue({
          firstName: agent.firstName ?? '',
          lastName: agent.lastName ?? '',
          email: agent.email ?? '',
          phone: agent.phone ?? '',
          agency: this.data.agencyName,
          role: this.role()?.id ?? '',
          isActive: agent.isActive ? 'Active' : 'Inactive',
        });
      }
    });
  }
  
  ngOnDestroy(): void {
    this.agencyStore.setAgent(null);
  }

  onSubmit() {
    const formValues = this.editUserForm.value;
    const agent: AgentViewModel = {
      ... formValues,
      isActive: formValues.isActive === 'Active' ? true : false,
      retailAgentId: this.agent()?.retailAgentId ?? 0,
    };
    this.dialogRef.close(agent);
  }
}
